import {ReactElement} from 'react';
import {Avatar, AvatarProps} from '@mui/material';

interface AvatarInputProps extends AvatarProps {
  src: string;
  alt: string;
  variant?: 'circular' | 'rounded' | 'square';
  className?: string;
}

const AvatarInput = (props: AvatarInputProps): ReactElement => {
  const {variant, className, alt, src, ...rest} = props;

  return (
    <Avatar
      src={src}
      alt={alt}
      variant={variant}
      className={className}
      {...rest}
    />
  );
};

export default AvatarInput;
